/* Silver Ocean — Raksha shared behaviours (landing + configurator).
   Minimal, dependency-free, idempotent. Driven entirely by data-attributes so
   sections stay declarative. Safe to load once; re-inits on Shopify section load. */
(function () {
  if (window.__soRakshaInit) { return; }
  window.__soRakshaInit = true;

  /* ---- scroll reveal ---- */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rk-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 })
    : null;
  function initReveal(root) {
    (root || document).querySelectorAll('[data-rk-reveal]:not(.rk-in)').forEach(function (el) {
      if (io) { io.observe(el); } else { el.classList.add('rk-in'); }
    });
  }

  /* ---- generic fade slider ---- */
  function initSlider(el) {
    if (el.__rk) { return; } el.__rk = true;
    var id = el.getAttribute('data-rk-id');
    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-rk-slide]'));
    if (slides.length < 2) { return; }
    var dots = id ? Array.prototype.slice.call(document.querySelectorAll('[data-rk-dots="' + id + '"] [data-rk-dot]')) : [];
    var autoplay = el.getAttribute('data-autoplay') !== 'false';
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 5000;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.style.opacity = k === i ? '1' : '0'; });
      dots.forEach(function (d, k) { d.classList.toggle('rk-on', k === i); });
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    // timer stored on the element so it can be cleared on shopify:section:unload (no leaks in the Theme Editor)
    function start() { if (autoplay) { stop(); el.__rkTimer = setInterval(next, speed); } }
    function stop() { if (el.__rkTimer) { clearInterval(el.__rkTimer); el.__rkTimer = null; } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    if (id) {
      document.querySelectorAll('[data-rk-arrow][data-rk-ref="' + id + '"]').forEach(function (a) {
        a.addEventListener('click', function () { (a.getAttribute('data-rk-arrow') === 'prev' ? prev : next)(); start(); });
      });
    }
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    var tx = 0;
    el.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (dx > 40) { prev(); } else if (dx < -40) { next(); }
      start();
    }, { passive: true });
    show(0); start();
  }

  /* ---- countdown ---- */
  function initCountdown(el) {
    if (el.__rk) { return; } el.__rk = true;
    var target = new Date(el.getAttribute('data-rk-countdown')).getTime();
    if (isNaN(target)) { return; }
    var out = el.querySelectorAll('[data-rk-cd]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var day = 864e5, hr = 36e5, min = 6e4;
      var d = Math.floor(diff / day); diff -= d * day;
      var h = Math.floor(diff / hr); diff -= h * hr;
      var m = Math.floor(diff / min); diff -= m * min;
      var s = Math.floor(diff / 1000);
      var vals = [String(d), pad(h), pad(m), pad(s)];
      out.forEach(function (o, k) { if (vals[k] !== undefined) { o.textContent = vals[k]; } });
    }
    tick(); el.__rkCd = setInterval(tick, 1000);
  }

  /* ---- video placeholder toggle ---- */
  function initVideo(el) {
    if (el.__rk) { return; } el.__rk = true;
    el.addEventListener('click', function () {
      var playing = el.classList.toggle('rk-playing');
      var icon = el.querySelector('[data-rk-video-icon]');
      var label = document.querySelector('[data-rk-video-label]');
      // icon uses the theme's .icon-play class; just nudge the play-triangle centring (no unicode swap; theme has no pause glyph)
      if (icon) { icon.style.marginLeft = playing ? '0' : '3px'; }
      if (label && label.getAttribute('data-playing')) { label.textContent = playing ? label.getAttribute('data-playing') : label.getAttribute('data-idle'); }
    });
  }

  function boot(root) {
    initReveal(root);
    (root || document).querySelectorAll('[data-rk-slider]').forEach(initSlider);
    (root || document).querySelectorAll('[data-rk-countdown]').forEach(initCountdown);
    (root || document).querySelectorAll('[data-rk-video]').forEach(initVideo);
  }

  if (document.readyState !== 'loading') { boot(document); }
  else { document.addEventListener('DOMContentLoaded', function () { boot(document); }); }
  // Re-init inside the Theme Editor when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  // Clear timers when a section is removed/re-rendered so intervals never leak in the Theme Editor.
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-rk-slider],[data-rk-countdown]').forEach(function (el) {
      if (el.__rkTimer) { clearInterval(el.__rkTimer); }
      if (el.__rkCd) { clearInterval(el.__rkCd); }
    });
  });
  window.__soRakshaBoot = boot;
})();
